// extracted by mini-css-extract-plugin
export default {"fullScreen":"fullScreen---ACx4L"};